import { render, staticRenderFns } from "./ServersReportView.vue?vue&type=template&id=37a316b0&scoped=true"
import script from "./ServersReportView.vue?vue&type=script&lang=js"
export * from "./ServersReportView.vue?vue&type=script&lang=js"
import style0 from "./ServersReportView.vue?vue&type=style&index=0&id=37a316b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a316b0",
  null
  
)

export default component.exports